import { FC } from "react";

const CellDisplay: FC<{ value: string | number | null | undefined, errorIf: boolean }> = ({ value, errorIf }) => {
    return errorIf
        ? <div style={{ color: 'var(--dcs-error-red)', fontWeight: 'bold' }}>
            {value ?? 'Not Assigned'}
        </div>
        : <>{value}</>;
}

export default CellDisplay;